import React from "react";
import { useNavigate } from "react-router";

const CardItem = ({data, route}) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (data.route) {
      if(data.route.startsWith('http')){
        window.open(data.route, '_blank');
      }
      else{
        data.route === "/novosti-detalji/" ? navigate(route + data.id) : navigate(data.route);
      }
    }
  }

  return(
    <div className="col-6 about_item_container about-border mb-4 mx-auto" style={{width: "20rem"}}>
      {data.date && (
          <div className="news_date ms-4">
              <p>NEWS</p>
              <div>{data.date}</div>
          </div>
      )}
      <div className="row">
        <img src={data.image} className="radius-top-16 p-0" alt=""></img>
      </div>
      <div className={`row justify-content-between card-body py-4 p-md-3 radius-bottom-16 card_item ${data.date ? 'grayBackground' : 'bg-white'}`}>
        <div className="text-start">
          <h5 className="card-title pt-2">{data.title}</h5>
          <p className="card-text">{data.content}</p>
        </div>
        <div className="row col-12 align-items-end justify-content-start ps-2 m-0">
          <div className="col-9 pb-2 text-center row justify-content-center">
            <div className="btn_load_more hover_btn_load_more" onClick={handleClick}>Više informacija</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardItem;